import { Typography } from '@mui/material';
import { Page } from 'common/components/Page';
import { StyledBreadcrumbs } from 'common/components/StyledBreadcrumbs';
import { DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_SLUG, DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_TITLE } from 'common/constants/admin';
import { Routes, RoutesNameMap } from 'common/constants/routes';
import { ErrorBoundary } from 'common/hocs/ErrorBoundary';

import { AccountLinkingDashboardTable } from './components/AccountLinkingDashboardTable';

export function AccountLinkingDashboard() {
    return (
        <Page
            title={RoutesNameMap.get(Routes.AccountLinkingDashboard)}
            header={(
                <Typography variant="h5" gutterBottom component="div" marginBottom={'1rem'} marginTop={'1rem'}>
                    <StyledBreadcrumbs
                        numberOfTabsToExcludeFromLinks={1}
                        guidNameMappings={[{
                            resourceName: DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_TITLE,
                            resourceId: DJ_ACCOUNT_LINKING_FAILURES_DASHBOARD_SLUG
                        }]}
                    />
                    {RoutesNameMap.get(Routes.AccountLinkingDashboard)}
                </Typography>
            )}
        >
            <ErrorBoundary>
                <AccountLinkingDashboardTable/>
            </ErrorBoundary>
        </Page>
    );
}
